export default angular.module('ApiUtils.khauth.auth', [])

